export const en = {
    'archived-experiment-name': 'Experiment {experimentId}'
};
